// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import './styles/app.scss'
import './utils/mixins'
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/component/legend'

import VueAnalytics from 'vue-analytics'

Vue.use(VeeValidate, {
  // 避免自動 inject 到所有 component
  inject: false,
  // 語系
  locale: 'zh_CN',
  // 驗證字串
  dictionary: {
    zh_TW: {
      messages: {
        required () {
          return '欄位不得空白'
        },
        email () {
          return '信箱格式錯誤'
        },
        numeric () {
          return '請輸入數字'
        },
        max (field, length) {
          return `最多${length}個字元`
        },
        date_format () {
          return '資料格式不符'
        }
      }
    },
    zh_CN: {
      messages: {
        required () {
          return '栏位不得空白'
        },
        email () {
          return '信箱格式错误'
        },
        numeric () {
          return '请输入数字'
        },
        max (field, length) {
          return `最多${length}个字元`
        },
        date_format () {
          return '资料格式不符'
        }
      }
    }
  }
})

Vue.component('v-chart', ECharts)
Vue.config.productionTip = false

// GA初始化

Vue.use(VueAnalytics, {
  id: 'UA-92393119-6', // 从配置中读取
  disableScriptLoader: true, // 必须在html中完成初始化，这里显式禁止去下载ga脚本
  router, // 确保路由切换时可以自动统计
  autoTracking: {
    pageviewOnLoad: false // 当通过网址进来时已经GA在初始化时就发起一次pageview的统计，这里不要重复统计
  },
  commands: {
    trackEvent (category = 'unknown', label = 'unknown') {
      this.$ga.event(category, 'Click', label)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js